import {useState, useEffect} from "react";
import { useNavigate } from "react-router-dom";
import {
    apiAssignShift,
    createShift,
    deliveryGuysWithStatus,
    getAllShifts,
    updateActionOrderPrice,
    updateShift
} from "../service/api/orders";


const Icons = {
    Plus: () => (
        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/>
        </svg>
    ),
    BarChart: () => (
        <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <line x1="18" y1="20" x2="18" y2="10"/><line x1="12" y1="20" x2="12" y2="4"/><line x1="6" y1="20" x2="6" y2="14"/>
        </svg>
    ),
    UserPlus: () => (
        <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/>
            <circle cx="9" cy="7" r="4"/>
            <line x1="19" y1="8" x2="19" y2="14"/><line x1="22" y1="11" x2="16" y2="11"/>
        </svg>
    ),
    Settings: () => (
        <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="12" cy="12" r="3"/>
            <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/>
        </svg>
    ),
    X: () => (
        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
        </svg>
    ),
    Close: () => (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
        </svg>
    ),
    Link: () => (
        <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"/>
            <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"/>
        </svg>
    ),
    Search: () => (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/>
        </svg>
    ),
    Clock: () => (
        <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/>
        </svg>
    ),
    Calendar: () => (
        <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/>
            <line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/>
        </svg>
    ),
    Layers: () => (
        <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <polygon points="12 2 2 7 12 12 22 7 12 2"/>
            <polyline points="2 17 12 22 22 17"/>
            <polyline points="2 12 12 17 22 12"/>
        </svg>
    ),
    EmptyBox: () => (
        <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
            <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/>
            <polyline points="3.27 6.96 12 12.01 20.73 6.96"/>
            <line x1="12" y1="22.08" x2="12" y2="12"/>
        </svg>
    ),
};

// ── COLORS ─────────────────────────────────────────────────────────────────
const C = {
    green:       "#1db954", greenDark: "#17a045",
    blue:        "#3b82f6", blueDark: "#6366f1",
    red:         "#ef4444", redLight: "#fee2e2",
    gray50:      "#f9fafb", gray100: "#f3f4f6",
    gray200:     "#e5e7eb", gray400: "#9ca3af",
    gray500:     "#6b7280", gray700: "#374151", gray900: "#111827",
    white:       "#ffffff",
    activeTag:   "#d1fae5", activeText: "#065f46",
    purple:      "#7c3aed", purpleLight: "#ede9fe",
};

const fmt12 = (t) => {
    if (!t) return "";
    const [h, m] = t.split(":").map(Number);
    return `${h % 12 || 12}:${String(m).padStart(2, "0")} ${h >= 12 ? "PM" : "AM"}`;
};


function useIsMobile(breakpoint = 768) {
    const [isMobile, setIsMobile] = useState(() => window.innerWidth < breakpoint);
    useEffect(() => {
        const handler = () => setIsMobile(window.innerWidth < breakpoint);
        window.addEventListener("resize", handler);
        return () => window.removeEventListener("resize", handler);
    }, [breakpoint]);
    return isMobile;
}


function Skeleton({ w = "100%", h = 14, r = 6, style: sx }) {
    return (
        <div style={{
            width: w, height: h, borderRadius: r,
            background: "linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)",
            backgroundSize: "200% 100%",
            animation: "shimmer 1.4s infinite",
            ...sx,
        }} />
    );
}

function ActionOrderPriceModal({ open, onClose, inData, setActionOrder }) {
    const [rules, setRules]   = useState(inData?.payload || []);
    const [active, setActive] = useState(inData?.active ?? true);
    const [editing, setEditing] = useState(false);
    const [saving, setSaving]   = useState(false);

    useEffect(() => {
        if (open) {
            setRules(inData?.payload || []);
            setActive(inData?.active ?? true);
            setEditing(false);
        }
    }, [open, inData]);

    const addRule    = () => setRules(r => [...r, { minutes: "", price: "" }]);
    const removeRule = (i) => setRules(r => r.filter((_, idx) => idx !== i));
    const updateRule = (i, key, value) => {
        const updated = [...rules];
        updated[i][key] = Number(value);
        setRules(updated);
    };

    const save = async () => {
        setSaving(true);
        try {
            await updateActionOrderPrice({ payload: rules, active });
            setActionOrder({payload: rules, active});
            setEditing(false);
            onClose();
        } catch (err) { console.error(err); }
        setSaving(false);
    };

    return (
        <Modal open={open} onClose={onClose} title="Action Order Rules">
            <div style={{ display: "flex", flexDirection: "column", gap: 20 }}>

                {/* ── ACTIVE TOGGLE ─────────────────────────────── */}
                <div style={{
                    display: "flex", alignItems: "center", justifyContent: "space-between",
                    padding: "14px 16px", borderRadius: 10,
                    background: active ? "#f0fdf4" : C.gray100,
                    border: `1px solid ${active ? "#bbf7d0" : C.gray200}`,
                    transition: "background .2s, border-color .2s",
                }}>
                    <div style={{ display: "flex", flexDirection: "column", gap: 2 }}>
                        <span style={{ fontSize: 13, fontWeight: 700, color: active ? "#166534" : C.gray700 }}>
                            {active ? "Rules Active" : "Rules Inactive"}
                        </span>
                        <span style={{ fontSize: 12, color: active ? "#4ade80" : C.gray400 }}>
                            {active ? "Pricing rules are being applied to orders" : "No pricing rules are applied"}
                        </span>
                    </div>

                    {/* Toggle pill */}
                    <button
                        onClick={() => editing && setActive(a => !a)}
                        disabled={!editing}
                        style={{
                            width: 44, height: 24, borderRadius: 12, border: "none",
                            background: active ? C.green : C.gray400,
                            cursor: editing ? "pointer" : "not-allowed",
                            position: "relative", transition: "background .2s",
                            flexShrink: 0, opacity: editing ? 1 : 0.7,
                        }}
                    >
                        <span style={{
                            position: "absolute", top: 3,
                            left: active ? 23 : 3,
                            width: 18, height: 18, borderRadius: "50%",
                            background: C.white,
                            transition: "left .2s",
                            boxShadow: "0 1px 3px rgba(0,0,0,.2)",
                            display: "block",
                        }} />
                    </button>
                </div>

                {/* ── RULES LIST ────────────────────────────────── */}
                <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
                    <div style={{
                        display: "grid", gridTemplateColumns: "1fr 1fr auto",
                        gap: 10, padding: "0 4px",
                    }}>
                        <span style={{ fontSize: 11, fontWeight: 700, color: C.gray500, textTransform: "uppercase", letterSpacing: "0.05em" }}>Minutes</span>
                        <span style={{ fontSize: 11, fontWeight: 700, color: C.gray500, textTransform: "uppercase", letterSpacing: "0.05em" }}>Price (₹)</span>
                        <span />
                    </div>

                    {rules.length === 0 && (
                        <div style={{
                            textAlign: "center", padding: "28px 16px", borderRadius: 10,
                            border: `1.5px dashed ${C.gray200}`, color: C.gray400, fontSize: 13,
                        }}>
                            {/*No rules yet. {editing && "Click "Add Rule" to add one."}*/}
                        </div>
                    )}

                    {rules.map((r, i) => (
                        <div key={i} style={{
                            display: "grid", gridTemplateColumns: "1fr 1fr auto",
                            gap: 10, alignItems: "center",
                            background: C.gray50, border: `1px solid ${C.gray200}`,
                            borderRadius: 8, padding: "10px 12px",
                        }}>
                            <input
                                type="number" placeholder="e.g. 30"
                                value={r.minutes}
                                readOnly={!editing}
                                onChange={e => updateRule(i, "minutes", e.target.value)}
                                style={{
                                    border: `1px solid ${editing ? C.gray200 : "transparent"}`,
                                    borderRadius: 6, padding: "7px 10px", fontSize: 13,
                                    color: C.gray900, background: editing ? C.white : "transparent",
                                    outline: "none", width: "100%", boxSizing: "border-box",
                                    fontWeight: 600,
                                }}
                            />
                            <input
                                type="number" placeholder="e.g. 50"
                                value={r.price}
                                readOnly={!editing}
                                onChange={e => updateRule(i, "price", e.target.value)}
                                style={{
                                    border: `1px solid ${editing ? C.gray200 : "transparent"}`,
                                    borderRadius: 6, padding: "7px 10px", fontSize: 13,
                                    color: C.gray900, background: editing ? C.white : "transparent",
                                    outline: "none", width: "100%", boxSizing: "border-box",
                                    fontWeight: 600,
                                }}
                            />
                            {editing
                                ? <Btn variant="danger" small onClick={() => removeRule(i)}><Icons.X /></Btn>
                                : <div style={{ width: 28 }} />
                            }
                        </div>
                    ))}

                    {editing && (
                        <button onClick={addRule} style={{
                            border: `1.5px dashed ${C.blue}`, borderRadius: 8,
                            background: "transparent", color: C.blue,
                            padding: "9px", fontSize: 13, fontWeight: 600,
                            cursor: "pointer", display: "flex", alignItems: "center",
                            justifyContent: "center", gap: 6,
                        }}>
                            <Icons.Plus /> Add Rule
                        </button>
                    )}
                </div>

                {/* ── FOOTER ACTIONS ────────────────────────────── */}
                <div style={{
                    display: "flex", justifyContent: "flex-end", gap: 10,
                    borderTop: `1px solid ${C.gray100}`, paddingTop: 16,
                }}>
                    {editing ? (
                        <>
                            <Btn variant="ghost" small onClick={() => setEditing(false)}>Cancel</Btn>
                            <Btn variant="success" small onClick={save} disabled={saving}>
                                {saving ? "Saving…" : "Save Changes"}
                            </Btn>
                        </>
                    ) : (
                        <>
                            <Btn variant="ghost" small onClick={onClose}>Close</Btn>
                            <Btn variant="primary" small onClick={() => setEditing(true)}>
                                <Icons.Settings /> Edit Rules
                            </Btn>
                        </>
                    )}
                </div>

            </div>
        </Modal>
    );
}

// ── BUTTON ─────────────────────────────────────────────────────────────────
function Btn({ children, onClick, variant = "primary", small, disabled, style: sx, fullWidth }) {
    const base = {
        border: "none", borderRadius: 6, cursor: disabled ? "not-allowed" : "pointer",
        fontWeight: 600, fontSize: small ? 12 : 13,
        padding: small ? "5px 10px" : "8px 18px",
        display: "inline-flex", alignItems: "center", justifyContent: "center", gap: 5,
        opacity: disabled ? .5 : 1, transition: "background .15s",
        width: fullWidth ? "100%" : undefined,
        ...sx,
    };
    const variants = {
        primary: { background: C.blue,        color: C.white },
        success: { background: C.green,        color: C.white },
        danger:  { background: C.red,          color: C.white },
        ghost:   { background: C.gray100,      color: C.gray700, border: `1px solid ${C.gray200}` },
        report:  { background: C.purpleLight,  color: C.purple,  border: "1px solid #c4b5fd" },
    };
    return (
        <button style={{ ...base, ...variants[variant] }} onClick={onClick} disabled={disabled}>
            {children}
        </button>
    );
}

// ── INPUT ──────────────────────────────────────────────────────────────────
function Input({ label, ...props }) {
    return (
        <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
            {label && <label style={{ fontSize: 12, fontWeight: 600, color: C.gray500 }}>{label}</label>}
            <input {...props} style={{ border: `1px solid ${C.gray200}`, borderRadius: 6, padding: "8px 10px", fontSize: 13, color: C.gray900, outline: "none", background: C.white, width: "100%", boxSizing: "border-box", ...props.style }} />
        </div>
    );
}

// ── CARD ───────────────────────────────────────────────────────────────────
function Card({ children, style: sx }) {
    return (
        <div style={{ background: C.white, borderRadius: 10, border: `1px solid ${C.gray200}`, boxShadow: "0 1px 4px rgba(0,0,0,.06)", padding: 24, ...sx }}>
            {children}
        </div>
    );
}

// ── MODAL ──────────────────────────────────────────────────────────────────
function Modal({ open, onClose, title, children }) {
    const isMobile = useIsMobile();
    if (!open) return null;

    const modalStyle = isMobile
        ? {
            position: "fixed", inset: 0, background: C.white,
            zIndex: 1000, display: "flex", flexDirection: "column",
        }
        : {
            position: "fixed", inset: 0, background: "rgba(0,0,0,.35)",
            zIndex: 1000, display: "flex", alignItems: "center",
            justifyContent: "center", padding: "20px", top: "40px",
        };

    const innerStyle = isMobile
        ? { display: "flex", flexDirection: "column", flex: 1, height: "100%" }
        : {
            background: C.white, borderRadius: 12, width: "900px",
            maxWidth: "95vw", height: "600px", display: "flex",
            flexDirection: "column", boxShadow: "0 20px 60px rgba(0,0,0,.18)",
        };

    return (
        <div style={modalStyle} onClick={isMobile ? undefined : onClose}>
            <div style={innerStyle} onClick={(e) => e.stopPropagation()}>
                <div style={{ padding: "18px 20px", borderBottom: `1px solid ${C.gray200}`, display: "flex", justifyContent: "space-between", alignItems: "center", flexShrink: 0 }}>
                    <h3 style={{ margin: 0, fontSize: 16 }}>{title}</h3>
                    <button onClick={onClose} style={{ border: "none", background: "none", cursor: "pointer", color: C.gray500, display: "flex", alignItems: "center", padding: 4 }}>
                        <Icons.Close />
                    </button>
                </div>
                <div style={{ flex: 1, overflowY: "auto", padding: isMobile ? 16 : 24 }}>{children}</div>
            </div>
        </div>
    );
}

// ── ASSIGN MODAL ───────────────────────────────────────────────────────────
function AssignShiftModal({ open, onClose, shift, onAssigned }) {
    const [boys, setBoys]       = useState([]);
    const [loading, setLoading] = useState(false);
    const [search, setSearch]   = useState("");

    useEffect(() => { if (open && shift) load(); }, [open, shift]);

    const load = async () => {
        setLoading(true);
        try {
            const res = await deliveryGuysWithStatus(shift?.id);
            if (res.success) setBoys(res.data);
        } catch {}
        setLoading(false);
    };

    const toggle = (id) => setBoys(prev => prev.map(b => b.id === id ? { ...b, assigned: !b.assigned } : b));

    const submit = async () => {
        const assigned = boys.filter(b => b.assigned).map(b => b.id);
        await apiAssignShift({ shift_id: shift.id, assigned });
        onAssigned(); onClose();
    };

    const filterAndSort = (list) => {
        if (!search) return list;
        const q = search.toLowerCase();
        return [...list].map(b => ({ ...b, match: b.name.toLowerCase().includes(q) })).sort((a, b) => b.match - a.match);
    };

    const assignedList   = filterAndSort(boys.filter(b =>  b.assigned));
    const unassignedList = filterAndSort(boys.filter(b => !b.assigned));

    return (
        <Modal open={open} onClose={onClose} title={`Manage Shift — ${shift?.shift_name}`}>
            <div style={{ marginBottom: 16, padding: 12, borderRadius: 8, background: C.gray50, border: `1px solid ${C.gray200}` }}>
                <strong>{shift?.shift_name}</strong><br/>
                <span style={{ fontSize: 12, color: C.gray500 }}>{fmt12(shift?.start_time)} → {fmt12(shift?.end_time)}</span>
            </div>

            {/* Search */}
            <div style={{ marginBottom: 16, position: "relative" }}>
                <span style={{ position: "absolute", left: 10, top: "50%", transform: "translateY(-50%)", color: C.gray400 }}><Icons.Search /></span>
                <input type="text" placeholder="Search delivery boys..." value={search}
                       onChange={(e) => setSearch(e.target.value)}
                       style={{ width: "100%", padding: "9px 12px 9px 32px", borderRadius: 8, border: `1px solid ${C.gray200}`, fontSize: 13, outline: "none", boxSizing: "border-box" }} />
            </div>

            {loading ? (
                <div style={{ display: "flex", flexWrap: "wrap", gap: 8, padding: 12 }}>
                    {Array.from({ length: 8 }).map((_, i) => <Skeleton key={i} w={80 + (i % 3) * 20} h={30} r={20} />)}
                </div>
            ) : (
                <>
                    <div style={{ marginBottom: 16 }}>
                        <h4 style={{ marginBottom: 8, fontSize: 13, color: C.gray700 }}>Assigned Delivery Boys</h4>
                        <div style={{ display: "flex", flexWrap: "wrap", gap: 8, padding: 12, borderRadius: 8, background: "#e6f9f3", minHeight: 48 }}>
                            {assignedList.length === 0
                                ? <span style={{ fontSize: 13, color: C.gray400, alignSelf: "center" }}>None assigned</span>
                                : assignedList.map(b => (
                                    <button key={b.id} onClick={() => toggle(b.id)}
                                            style={{ padding: "5px 12px", borderRadius: 20, border: "none", background: "#2ebf91", color: "#fff", cursor: "pointer", fontSize: 12, fontWeight: 600 }}>
                                        {b.name}
                                    </button>
                                ))}
                        </div>
                    </div>
                    <div style={{ marginBottom: 20 }}>
                        <h4 style={{ marginBottom: 8, fontSize: 13, color: C.gray700 }}>Unassigned Delivery Boys</h4>
                        <div style={{ display: "flex", flexWrap: "wrap", gap: 8, padding: 12, borderRadius: 8, background: C.gray50, border: `1px solid ${C.gray200}`, minHeight: 48 }}>
                            {unassignedList.length === 0
                                ? <span style={{ fontSize: 13, color: C.gray400, alignSelf: "center" }}>All assigned</span>
                                : unassignedList.map(b => (
                                    <button key={b.id} onClick={() => toggle(b.id)}
                                            style={{ padding: "5px 12px", borderRadius: 20, border: `1px solid ${C.gray200}`, background: C.white, color: C.gray700, cursor: "pointer", fontSize: 12, fontWeight: 600 }}>
                                        {b.name}
                                    </button>
                                ))}
                        </div>
                    </div>
                </>
            )}

            <div style={{ display: "flex", justifyContent: "flex-end", gap: 10 }}>
                <Btn variant="ghost" onClick={onClose}>Cancel</Btn>
                <Btn variant="primary" onClick={submit} disabled={loading}>Update Assignments</Btn>
            </div>
        </Modal>
    );
}

// ── SHIFT FORM MODAL ───────────────────────────────────────────────────────
const DAYS = ["Monday","Tuesday","Wednesday","Thursday","Friday","Saturday","Sunday"];

function ShiftFormModal({ open, onClose, onSubmit, initial }) {
    const isMobile = useIsMobile();
    const [form, setForm] = useState({ shift_name: "", start_time: "", end_time: "", from_day: "", to_day: "", payout_rules: [] });

    useEffect(() => {
        setForm(initial ? {
            shift_name: initial.shift_name || "", start_time: initial.start_time || "",
            end_time: initial.end_time || "", from_day: initial.from_day || "",
            to_day: initial.to_day || "", payout_rules: initial.payout_rules || [],
        } : { shift_name: "", start_time: "", end_time: "", from_day: "", to_day: "", payout_rules: [] });
    }, [initial, open]);

    const addRule    = () => setForm(f => ({ ...f, payout_rules: [...f.payout_rules, { percent: "", amount: "" }] }));
    const removeRule = (i) => setForm(f => ({ ...f, payout_rules: f.payout_rules.filter((_, idx) => idx !== i) }));
    const updateRule = (i, key, value) => {
        const updated = [...form.payout_rules]; updated[i][key] = value; setForm({ ...form, payout_rules: updated });
    };
    const submit = () => {
        if (form.payout_rules.some(r => !r.percent || !r.amount)) { alert("Fill all payout rules"); return; }
        onSubmit(form); onClose();
    };
    const selectStyle = { border: `1px solid ${C.gray200}`, borderRadius: 6, padding: "8px 10px", fontSize: 13, color: C.gray900, background: C.white, outline: "none", width: "100%" };

    return (
        <Modal open={open} onClose={onClose} title={initial ? "Edit Shift" : "Create Shift"}>
            <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
                <Input label="Shift Name" value={form.shift_name} onChange={(e) => setForm({ ...form, shift_name: e.target.value })} />

                {/* Start / End time — stack on mobile */}
                <div style={{ display: "grid", gridTemplateColumns: isMobile ? "1fr" : "1fr 1fr", gap: 12 }}>
                    <Input type="time" label="Start Time" value={form.start_time} onChange={(e) => setForm({ ...form, start_time: e.target.value })} />
                    <Input type="time" label="End Time"   value={form.end_time}   onChange={(e) => setForm({ ...form, end_time: e.target.value })} />
                </div>

                {/* From / To day — stack on mobile */}
                <div style={{ display: "grid", gridTemplateColumns: isMobile ? "1fr" : "1fr 1fr", gap: 12 }}>
                    {["from_day","to_day"].map(field => (
                        <div key={field} style={{ display: "flex", flexDirection: "column", gap: 4 }}>
                            <label style={{ fontSize: 12, fontWeight: 600, color: C.gray500 }}>{field === "from_day" ? "From Day" : "To Day"}</label>
                            <select value={form[field]} onChange={(e) => setForm({ ...form, [field]: e.target.value })} style={selectStyle}>
                                <option value="">Select day</option>
                                {DAYS.map(d => <option key={d} value={d}>{d}</option>)}
                            </select>
                        </div>
                    ))}
                </div>

                <div>
                    <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 8 }}>
                        <strong style={{ fontSize: 13 }}>Payout Rules</strong>
                        <Btn small onClick={addRule}><Icons.Plus /> Add</Btn>
                    </div>
                    <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
                        {form.payout_rules.map((r, i) => (
                            <div key={i} style={{ display: "grid", gridTemplateColumns: "1fr 1fr auto", gap: 10, alignItems: "center" }}>
                                <Input placeholder="Percent %" type="number" value={r.percent} onChange={(e) => updateRule(i, "percent", e.target.value)} />
                                <Input placeholder="Amount ₹"  type="number" value={r.amount}  onChange={(e) => updateRule(i, "amount",  e.target.value)} />
                                <Btn variant="danger" small onClick={() => removeRule(i)}><Icons.X /></Btn>
                            </div>
                        ))}
                    </div>
                </div>

                <div style={{ display: "flex", flexDirection: isMobile ? "column-reverse" : "row", justifyContent: "flex-end", gap: 10 }}>
                    <Btn variant="ghost" onClick={onClose} fullWidth={isMobile}>Cancel</Btn>
                    <Btn variant="primary" onClick={submit} fullWidth={isMobile}>{initial ? "Update" : "Create"}</Btn>
                </div>
            </div>
        </Modal>
    );
}

// ── SKELETON CARD (mobile) ─────────────────────────────────────────────────
function SkeletonCard() {
    return (
        <div style={{ background: C.white, borderRadius: 10, border: `1px solid ${C.gray200}`, padding: 16, display: "flex", flexDirection: "column", gap: 10 }}>
            <Skeleton w="60%" h={16} />
            <Skeleton w="40%" h={13} />
            <Skeleton w="80%" h={13} />
            <div style={{ display: "flex", gap: 8, marginTop: 4 }}>
                <Skeleton w={80} h={30} r={6} />
                <Skeleton w={80} h={30} r={6} />
                <Skeleton w={60} h={30} r={6} />
            </div>
        </div>
    );
}

// ── SKELETON ROW (desktop) ─────────────────────────────────────────────────
function SkeletonRow({ cols = 8 }) {
    return (
        <tr>
            {Array.from({ length: cols }).map((_, i) => (
                <td key={i} style={{ padding: "18px 20px" }}>
                    <Skeleton w={i === cols - 1 ? 120 : `${55 + (i * 17) % 45}%`} h={13} />
                </td>
            ))}
        </tr>
    );
}

// ── SHIFT CARD (mobile view) ───────────────────────────────────────────────
function ShiftCard({ shift, onReport, onAssign, onEdit }) {
    return (
        <div style={{ background: C.white, borderRadius: 10, border: `1px solid ${C.gray200}`, boxShadow: "0 1px 4px rgba(0,0,0,.06)", padding: 16, display: "flex", flexDirection: "column", gap: 10 }}>
            {/* Name + Days row */}
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", gap: 8 }}>
                <span style={{ fontSize: 15, fontWeight: 700, color: C.gray900 }}>{shift.shift_name}</span>
                {shift.from_day && shift.to_day && (
                    <span style={{ background: "#dbeafe", color: "#1d4ed8", padding: "3px 8px", borderRadius: 12, fontSize: 11, fontWeight: 600, whiteSpace: "nowrap", display: "inline-flex", alignItems: "center", gap: 3 }}>
                        <Icons.Calendar />
                        {shift.from_day.slice(0,3)} → {shift.to_day.slice(0,3)}
                    </span>
                )}
            </div>

            {/* Times */}
            <div style={{ display: "flex", gap: 16, flexWrap: "wrap" }}>
                <span style={{ display: "flex", alignItems: "center", gap: 5, fontSize: 13, color: C.gray700 }}>
                    <span style={{ color: C.green }}><Icons.Clock /></span>
                    {fmt12(shift.start_time)}
                </span>
                <span style={{ color: C.gray400, fontSize: 13 }}>→</span>
                <span style={{ display: "flex", alignItems: "center", gap: 5, fontSize: 13, color: C.gray700 }}>
                    <span style={{ color: C.red }}><Icons.Clock /></span>
                    {fmt12(shift.end_time)}
                </span>
            </div>

            {/* Payout rules */}
            {(shift.payout_rules || []).length > 0 && (
                <div style={{ display: "flex", flexWrap: "wrap", gap: 4 }}>
                    {shift.payout_rules.map((r, i) => (
                        <span key={i} style={{ fontSize: 11, color: C.gray700, background: C.gray50, border: `1px solid ${C.gray200}`, padding: "2px 8px", borderRadius: 6 }}>
                            {r.percent}% → ₹{r.amount}
                        </span>
                    ))}
                </div>
            )}

            {/* Created / Updated */}
            <div style={{ display: "flex", gap: 12, flexWrap: "wrap" }}>
                {shift.created_at && (
                    <span style={{ fontSize: 11, color: C.gray400 }}>
                        Created: {new Date(shift.created_at).toLocaleString('en-IN', { day:'2-digit', month:'short', year:'numeric', hour:'2-digit', minute:'2-digit', timeZone:'Asia/Kolkata', hour12:false })}
                    </span>
                )}
                {shift.updated_at && (
                    <span style={{ fontSize: 11, color: C.gray400 }}>
                        Updated: {new Date(shift.updated_at).toLocaleString('en-IN', { day:'2-digit', month:'short', year:'numeric', hour:'2-digit', minute:'2-digit', timeZone:'Asia/Kolkata', hour12:false })}
                    </span>
                )}
            </div>

            {/* Actions */}
            <div style={{ display: "flex", gap: 8, flexWrap: "wrap", paddingTop: 4, borderTop: `1px solid ${C.gray100}` }}>
                <Btn small variant="report"  onClick={onReport}><Icons.BarChart /> Report</Btn>
                <Btn small variant="primary" onClick={onAssign}><Icons.UserPlus /> Assign</Btn>
                <Btn small variant="ghost"   onClick={onEdit}><Icons.Settings /> Edit</Btn>
            </div>
        </div>
    );
}

// ── MAIN PAGE ──────────────────────────────────────────────────────────────
export default function ShiftManagement() {
    const navigate  = useNavigate();
    const isMobile  = useIsMobile();
    const [shifts, setShifts]             = useState([]);
    const [loading, setLoading]           = useState(true);
    const [editTarget, setEditTarget]     = useState(null);
    const [assignTarget, setAssignTarget] = useState(null);
    const [showCreate, setShowCreate]     = useState(false);
    const [actionOrderPrice, setActionOrderPrice] =  useState(null);

    const [modalOpen, setModalOpen] = useState(false);


    useEffect(() => {
        setLoading(true);

        getAllShifts()
            .then(r => {
                if (r.success) {
                    setShifts(r.data?.shifts);
                    console.log("r. ", r?.data);
                    setActionOrderPrice(r?.data?.actionOrderPrice);
                }
            })
            .finally(() => setLoading(false));

    }, []);

    const handleCreate = async (data) => {
        const res = await createShift(data);
        if (res.success) setShifts(s => [...s, res.data]);
    };
    const handleUpdate = async (data) => {
        const res = await updateShift(editTarget.id, data);
        if (res.success) setShifts(s => s.map(x => x.id === editTarget.id ? res.data : x));
    };

    return (
        <>
            <style>{`
                @keyframes shimmer {
                    0%   { background-position: 200% 0; }
                    100% { background-position: -200% 0; }
                }
                .shift-row:hover { background: #fafafa; }
                .action-btn { transition: opacity .15s, transform .1s; }
                .action-btn:hover { opacity: .85; transform: translateY(-1px); }
            `}</style>

            <div style={{ fontFamily: "'Segoe UI', sans-serif", background: C.gray50, minHeight: "100vh" }}>
                <div style={{padding: isMobile ? "20px 16px 80px" : "28px 28px 100px"}}>

                    {/* ── HEADER ─────────────────────────────────────────── */}
                    <div style={{
                        display: "flex",
                        flexDirection: isMobile ? "column" : "row",
                        justifyContent: "space-between",
                        alignItems: isMobile ? "flex-start" : "center",
                        gap: isMobile ? 14 : 0,
                        marginBottom: 24,
                    }}>
                        <div>
                            <h1 style={{
                                margin: 0,
                                fontSize: isMobile ? 18 : 20,
                                color: C.gray900,
                                fontWeight: 800
                            }}>Shift Management</h1>
                            <p style={{margin: "2px 0 0", fontSize: 13, color: C.gray400}}>Create shifts and assign
                                delivery boys</p>
                        </div>

                        <div style={{
                            display: "flex",
                            gap: 10,
                            flexDirection: "row",
                            flexWrap: isMobile ? "wrap" : "nowrap",
                            width: isMobile ? "100%" : "auto"
                        }}>
                            <Btn
                                variant="ghost"
                                onClick={() => setModalOpen(true)}
                                fullWidth={isMobile}
                            >
                                <Icons.Settings/> Action Pricing
                            </Btn>
                            <Btn
                                variant="primary"
                                onClick={() => setShowCreate(true)}
                                fullWidth={isMobile}
                            >
                                <Icons.Plus/> Add New Shift
                            </Btn>
                        </div>
                    </div>

                    {/* ── MOBILE: CARD LIST ──────────────────────────────── */}
                    {isMobile && (
                        <div style={{display: "flex", flexDirection: "column", gap: 12}}>
                            {loading && Array.from({length: 3}).map((_, i) => <SkeletonCard key={i}/>)}

                            {!loading && shifts.length === 0 && (
                                <div style={{
                                    textAlign: "center",
                                    padding: "56px 20px",
                                    color: C.gray400,
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                    gap: 10
                                }}>
                                    <Icons.EmptyBox/>
                                    <div style={{fontSize: 14, fontWeight: 600, color: C.gray500}}>No shifts yet</div>
                                    <div style={{fontSize: 13}}>Tap "Add New Shift" to get started</div>
                                </div>
                            )}

                            {!loading && shifts.map(shift => (
                                <ShiftCard
                                    key={shift.id}
                                    shift={shift}
                                    onReport={() => navigate(`/shifts/${shift.id}/report`)}
                                    onAssign={() => setAssignTarget(shift)}
                                    onEdit={() => setEditTarget(shift)}
                                />
                            ))}
                        </div>
                    )}

                    {/* ── DESKTOP: TABLE ─────────────────────────────────── */}
                    {!isMobile && (
                        <Card style={{padding: 0, overflow: "hidden"}}>
                            <div style={{overflowX: "auto"}}>
                                <table style={{width: "100%", borderCollapse: "collapse", minWidth: 700}}>
                                    <thead>
                                    <tr style={{borderBottom: `1px solid ${C.gray200}`}}>
                                        {[
                                            {label: "Shift Name", icon: <Icons.Layers/>},
                                            {label: "Start Time", icon: <Icons.Clock/>},
                                            {label: "End Time", icon: <Icons.Clock/>},
                                            {label: "Days", icon: <Icons.Calendar/>},
                                            {label: "Payout Rules"},
                                            {label: "Created At"},
                                            {label: "Updated At"},
                                            {label: "Actions"},
                                        ].map(({label, icon}, i) => (
                                            <th key={i} style={{
                                                padding: "13px 20px",
                                                textAlign: "left",
                                                fontSize: 12,
                                                fontWeight: 700,
                                                color: C.gray500,
                                                background: C.white,
                                                whiteSpace: "nowrap"
                                            }}>
                                                <div style={{display: "flex", alignItems: "center", gap: 5}}>
                                                    {icon && <span style={{color: C.gray400}}>{icon}</span>}
                                                    {label}
                                                </div>
                                            </th>
                                        ))}
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {loading && Array.from({length: 4}).map((_, i) => <SkeletonRow key={i} cols={8}/>)}

                                    {!loading && shifts.length === 0 && (
                                        <tr>
                                            <td colSpan={8} style={{padding: "56px 20px", textAlign: "center"}}>
                                                <div style={{
                                                    display: "flex",
                                                    flexDirection: "column",
                                                    alignItems: "center",
                                                    gap: 10,
                                                    color: C.gray400
                                                }}>
                                                    <Icons.EmptyBox/>
                                                    <div style={{fontSize: 14, fontWeight: 600, color: C.gray500}}>No
                                                        shifts yet
                                                    </div>
                                                    <div style={{fontSize: 13}}>Click "Add New Shift" to get started
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                    )}

                                    {!loading && shifts.map((shift, idx) => (
                                        <tr key={shift.id} className="shift-row"
                                            style={{
                                                borderBottom: idx < shifts.length - 1 ? `1px solid ${C.gray100}` : "none",
                                                transition: "background .1s"
                                            }}>
                                            <td style={{padding: "15px 20px"}}>
                                                <span style={{
                                                    fontSize: 14,
                                                    fontWeight: 600,
                                                    color: C.gray900
                                                }}>{shift.shift_name}</span>
                                            </td>
                                            <td style={{padding: "15px 20px", fontSize: 13, color: C.gray700}}>
                                                <div style={{display: "flex", alignItems: "center", gap: 5}}>
                                                    <span style={{color: C.green}}><Icons.Clock/></span>
                                                    {fmt12(shift.start_time)}
                                                </div>
                                            </td>
                                            <td style={{padding: "15px 20px", fontSize: 13, color: C.gray700}}>
                                                <div style={{display: "flex", alignItems: "center", gap: 5}}>
                                                    <span style={{color: C.red}}><Icons.Clock/></span>
                                                    {fmt12(shift.end_time)}
                                                </div>
                                            </td>
                                            <td style={{padding: "15px 20px", fontSize: 13, color: C.gray700}}>
                                                {shift.from_day && shift.to_day
                                                    ? <span style={{
                                                        background: "#dbeafe",
                                                        color: "#1d4ed8",
                                                        padding: "4px 10px",
                                                        borderRadius: 12,
                                                        fontSize: 12,
                                                        fontWeight: 600,
                                                        display: "inline-flex",
                                                        alignItems: "center",
                                                        gap: 4
                                                    }}>
                                        <Icons.Calendar/>
                                                        {shift.from_day.slice(0, 3)} → {shift.to_day.slice(0, 3)}
                                      </span>
                                                    : <span style={{color: C.gray400}}>—</span>}
                                            </td>
                                            <td style={{padding: "15px 20px"}}>
                                                <div style={{display: "flex", flexDirection: "column", gap: 4}}>
                                                    {(shift.payout_rules || []).map((r, i) => (
                                                        <div key={i} style={{
                                                            fontSize: 12,
                                                            color: C.gray700,
                                                            background: C.gray50,
                                                            padding: "3px 8px",
                                                            borderRadius: 6,
                                                            display: "inline-block",
                                                            width: "fit-content"
                                                        }}>
                                                            {r.percent}% → ₹{r.amount}
                                                        </div>
                                                    ))}
                                                    {(shift.payout_rules || []).length === 0 &&
                                                        <span style={{color: C.gray400, fontSize: 12}}>—</span>}
                                                </div>
                                            </td>
                                            <td style={{
                                                padding: "15px 20px",
                                                fontSize: 12,
                                                color: C.gray500,
                                                whiteSpace: "nowrap"
                                            }}>
                                                {shift.created_at
                                                    ? new Date(shift.created_at).toLocaleString('en-IN', {
                                                        day: '2-digit',
                                                        month: 'short',
                                                        year: 'numeric',
                                                        hour: '2-digit',
                                                        minute: '2-digit',
                                                        timeZone: 'Asia/Kolkata',
                                                        hour12: false
                                                    })
                                                    : "—"}
                                            </td>
                                            <td style={{
                                                padding: "15px 20px",
                                                fontSize: 12,
                                                color: C.gray500,
                                                whiteSpace: "nowrap"
                                            }}>
                                                {shift.updated_at
                                                    ? new Date(shift.updated_at).toLocaleString('en-IN', {
                                                        day: '2-digit',
                                                        month: 'short',
                                                        year: 'numeric',
                                                        hour: '2-digit',
                                                        minute: '2-digit',
                                                        timeZone: 'Asia/Kolkata',
                                                        hour12: false
                                                    })
                                                    : "—"}
                                            </td>
                                            <td style={{padding: "15px 20px"}}>
                                                <div style={{
                                                    display: "flex",
                                                    gap: 6,
                                                    justifyContent: "flex-end",
                                                    flexWrap: "wrap"
                                                }}>
                                                    <Btn small variant="report" className="action-btn"
                                                         onClick={() => navigate(`/shifts/${shift.id}/report`)}>
                                                        <Icons.BarChart/> Report
                                                    </Btn>
                                                    <Btn small variant="primary" className="action-btn"
                                                         onClick={() => setAssignTarget(shift)}>
                                                        <Icons.UserPlus/> Assign
                                                    </Btn>
                                                    <Btn small variant="ghost" className="action-btn"
                                                         onClick={() => setEditTarget(shift)}>
                                                        <Icons.Settings/> Edit
                                                    </Btn>
                                                </div>
                                            </td>
                                        </tr>
                                    ))}
                                    </tbody>
                                </table>
                            </div>
                        </Card>
                    )}
                </div>

                <AssignShiftModal open={!!assignTarget} shift={assignTarget} onClose={() => setAssignTarget(null)}
                                  onAssigned={() => {
                                  }}/>
                <ShiftFormModal open={showCreate} onClose={() => setShowCreate(false)} onSubmit={handleCreate}/>
                <ShiftFormModal open={!!editTarget} onClose={() => setEditTarget(null)} onSubmit={handleUpdate}
                                initial={editTarget}/>

                <ActionOrderPriceModal open={modalOpen} onClose={() => setModalOpen(false)} inData={actionOrderPrice} setActionOrder={setActionOrderPrice} />
            </div>
        </>
    );
}